<template lang="pug">
div
  p Selecione por situação:
  app-plotly(nomeDiv="DaeMunicipios", :dados="buildGraficoTipoProcesso", :layout="layout")
</template>
<script>
import AppPlotly from '@/components/AppPlotly'
import Utils from '@/utils/utils'
import _ from 'lodash'

export default {
  components: {
    AppPlotly
  },

  props: {
    dadosDb: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      layout: {
        barmode: 'stack',
        yaxis: {
          title: 'Valor (R$)',
          hoverformat: ',.2f',
          fixedrange: true
        },
        xaxis: {
          range: [], // Quantidade de processo a serem exibidos por default
          automargin: true,
          tickangle: 45
        },
        hoverlabel: {
          namelength: -1
        },
        separators: ',.',
        margin: {
          l: 80,
          r: 40,
          t: 40,
          b: 60,
          pad: 4
        },
        legend: {
          x: -0.05,
          y: 1.20,
          orientation: 'h'
        },
        annotations: []
      },
      daeTipoRecebidos: {
        x: [],
        y: [],
        name: 'Recebido',
        hovertemplate: 'R$ %{y}',
        type: 'bar',
        width: 0,
        marker: { color: '#39da84' },
        hoverinfo: 'text'
      },
      daeTipoVencidos: {
        x: [],
        y: [],
        name: 'Vencido',
        hovertemplate: 'R$ %{y}',
        type: 'bar',
        width: 0,
        marker: { color: '#e74c3c' }
      },
      daeAguardandoPagamento: {
        x: [],
        y: [],
        name: 'Aguardando Pagamento',
        hovertemplate: 'R$ %{y}',
        type: 'bar',
        width: 0,
        marker: { color: '#3498db' }
      }
    }
  },

  computed: {
    buildGraficoTipoProcesso () {
      if (_.isEmpty(this.dadosDb)) {
        return []
      }

      // Resetando os dados que são exibidos no gráfico
      this.setDadosEmpty()

      // Setando os novos dados da do filtro no gráfico
      this.dadosDb.forEach((item) => {
        this.setAguardandoPagamentoDadosGrafico(item)
        this.setVencidoDadosGrafico(item)
        this.setQuitadoDadosGrafico(item)
        this.setAnnotationsGrafico(item)
      })

      // Setando a quantidade de exibição em casos de muitos dados no gráfico
      this.setRangeGraph()

      return [this.daeAguardandoPagamento, this.daeTipoVencidos, this.daeTipoRecebidos]
    }
  },

  methods: {
    formatTotal (valor) {
      return Utils.format(valor)
    },

    setDadosEmpty () {
      // Resetando os dados que são exibidos no gráfico
      this.daeAguardandoPagamento.x = []; //eslint-disable-line
      this.daeAguardandoPagamento.y = []; //eslint-disable-line

      this.daeTipoVencidos.x = []; //eslint-disable-line
      this.daeTipoVencidos.y = []; //eslint-disable-line

      this.daeTipoRecebidos.x = []; //eslint-disable-line
      this.daeTipoRecebidos.y = []; //eslint-disable-line

      this.layout.annotations = []; //eslint-disable-line
    },

    setAnnotationsGrafico (item) {
      this.layout.annotations.push({
        x: item.label,
        y: item.emitido,
        text: `Total: ${Utils.padraoMoedaBrasil.format(item.emitido)}`,
        yanchor: 'bottom',
        showarrow: true,
        arrowhead: 7,
        ax: 0,
        ay: -20,
        bgcolor: '#F3F7FA',
        bordercolor: '#000',
        borderpad: 4,
        font: {
          color: '#000'
        }
      })
    },

    setRangeGraph () {
      if (this.dadosDb.length > 10) {
        this.layout.xaxis.range = [-0.5, 10.5]; //eslint-disable-line
      }
    },

    setAguardandoPagamentoDadosGrafico (item) {
      this.daeAguardandoPagamento.y.push(item.aguardandoPagamento)
      this.daeAguardandoPagamento.x.push(item.label)
      this.daeAguardandoPagamento.width = this.dadosDb.length < 2 ? 0.3 : 0.8
    },

    setVencidoDadosGrafico (item) {
      this.daeTipoVencidos.y.push(item.vencido)
      this.daeTipoVencidos.x.push(item.label)
      this.daeTipoVencidos.width = this.dadosDb.length < 2 ? 0.3 : 0.8
    },

    setQuitadoDadosGrafico (item) {
      this.daeTipoRecebidos.y.push(item.quitado)
      this.daeTipoRecebidos.x.push(item.label)
      this.daeTipoRecebidos.width = this.dadosDb.length < 2 ? 0.3 : 0.8
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/relatoriosDae/components/DaeMunicipio.vue